import React, { useState } from 'react'
import { toast } from 'react-toastify'
import { getInvoiceImageUrl } from 'src/services/purchase/purchaseService'
import { ModalInvoicePrint } from './ModalInvoicePrint'
import * as S from './styles'

export const InvoicePrint = ({ invoiceKeys }) => {
  const [invoiceUrls, setInvoiceUrls] = useState([])

  const printInvoices = async (e) => {
    e.preventDefault()

    if (invoiceKeys.length === 0) {
      toast.error('Fornecimento não possui notas fiscais')
      return
    }

    const _invoiceUrls = []

    for await (const invoiceKey of invoiceKeys) {
      const result = await getInvoiceImageUrl(invoiceKey)
      if (result.isOk) {
        _invoiceUrls.push(result.data.image_url)
      } else {
        toast.error('Falha ao carregar a nota fiscal')
      }
    }
    setInvoiceUrls(_invoiceUrls)
  }

  return (
    <S.IconWrapper>
      <S.PrintInvoiceIcon
        aria-label="imprimir-nota-fiscal"
        onClick={printInvoices}
      />
      <ModalInvoicePrint
        invoiceUrls={invoiceUrls}
        cancelAction={() => setInvoiceUrls([])}
      />
    </S.IconWrapper>
  )
}
